<template>
  <div class="stage-products">
    <AddProductModal />

    <!-- Add button (commented out in original) -->
    <!-- <button type="button" @click.prevent="$store.commit('showAddModal')">Add Product</button> -->

    <div class="product-category-row">
      <button
        type="button"
        class="btn primary"
        v-for="type in $store.getters.getProductTypes"
        :key="type.id || type.name" 
        @click="chooseType(type)"
        :class="{ inactive: $store.state.addItemModalData.type !== type }"
      >
      {{ type.name }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-plus">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </button>
    </div>

    <div class="product-grid" v-if="$store.getters.getProducts && $store.getters.getProducts?.length > 0 && !$store.state.isAddModalOpen">
      <div
        class="product-grid-item"
        v-for="product in $store.getters.getProducts"
        :key="product.id || product.name"
        @click="chooseProduct(product)"
      >
        <img class="product-image" :src="product.icon" alt="" />
        <p class="product-title" v-if="product.name">{{ product.name }}</p>
        <p class="product-specifications" v-if="product.dimensions">{{ product.dimensions }}</p>
      </div>
    </div>

    <div class="product-list" v-if="$store.state.cart.length > 0">
      <div
        class="product-list-category"
        v-for="type in productTypes"
        :key="type.id"
      >
      <div v-if="storeCart && storeCart.some(p => p.type?.id === type?.id)">
          <div class="product-list-category-title">{{ type.name }}</div>
          <ProductListItem
            class="product-list-item"
            v-for="(product, index) in storeCart.filter((p) => p.type.id === type.id)"
            :key="`${product.product.id}-${product.variation.id}`"
            :name="product.product.name"
            :quantity="product.quantity"
            :quantityType="product.quantityType"
            :variation="product.variation.name"
            :index="storeCart.indexOf(product)"
            @onRemove="removeFromIndex(storeCart.indexOf(product))"
            @onEdit="editFromIndex(storeCart.indexOf(product))"
          />
        </div>
        </div>
    </div>

    <div v-else class="empty-message">
      You currently have no products in your quotation. Start by adding some above!
    </div>
  </div>
</template>

<script>
import AddProductModal from "@/components/add-product-modal.vue";
import ProductListItem from "@/components/product-list-item.vue";
export default {
	name: "stage-products",
	methods: {
		removeFromIndex(index) {
			this.$store.commit("removeCartItem", index);
		},
		editFromIndex(index) {
			this.$store.commit("enableEditing", index);
			this.$store.commit("showAddModal");
		},
		chooseType(type) {
			this.$store.commit("updateAddModalData", {
				type,
			});
		},
		chooseProduct(product) {
			this.$store.commit("updateAddModalData", {
				product,
			});
			this.$store.commit("showAddModal");
		},
	},
	computed: {
		productTypes() {
			return this.$store.getters.getProductTypes;
		},
		storeCart() {
			return this.$store.state.cart;
		},
	},
	components: {
		AddProductModal,
		ProductListItem,
	},
};
</script>

<style lang="scss" scoped>
.product-category-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
    .btn {
        flex: 0 0 auto;
        width: auto;
    }

    @media only screen and (max-width: 768px) {
        .btn {
            flex-grow: 1;
            flex-basis: calc(50% - 10px);
            box-sizing: border-box;
        }
    }
}

.product-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    margin-bottom: 20px;

    @media only screen and (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    .product-grid-item {
        border: 1px solid #efefef;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        padding: 20px;
        transition: border 100ms ease-out;
        cursor: pointer;
        p {
            margin: 0;
            text-align: center;
        }
        .product-image {
            max-width: 80%;
            transition: transform 100ms ease-out;
        }
        .product-title {
            font-weight: 600;
            color: $cl-primary;
        }
        .product-specifications {
            margin-top: 6px;
            opacity: 0.65;
        }

        &:hover {
            border: 1px solid $cl-primary;
            .product-image {
                transform: scale(1.1);
            }
        }
    }
}

.empty-message {
    opacity: 0.75;
}

.product-list {
    .product-list-category {
        &:not(:last-child) {
            margin-bottom: 20px;
        }
        .product-list-category-title {
            color: #a7a7a7;
            font-weight: 600;
            font-size: 14px;
            margin-bottom: 4px;
        }
    }
    .product-list-item:not(:last-child) {
        margin-bottom: 10px;
    }
}
</style>